import React from 'react'
import { IconButton, styled } from '@mui/material'
import { CloseIcon } from 'asterX-UI/Icons'
import { iconCloseButtonStyle } from './buttons.styles'

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  ...iconCloseButtonStyle(theme)
}))

const IconCloseButton = props => {
  const { children, ...other } = props
  return (
    <StyledIconButton {...other}>
      <CloseIcon />
    </StyledIconButton>
  )
}

export default IconCloseButton
